export const TypographyIngress = "text-header22 md:text-header24 font-sans normal text-sort-200  text-center mb-16 "

export const Ingress = (ingress) => <p className={TypographyIngress} {...ingress} />

export const TypographyParagraph = "font-sans font-normal text-body18 mb-8 lg:mb-12  " // p
export const Paragraph = (props) => <p className={TypographyParagraph} {...props} />
